import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperItem,
} from "../../../common/component/Index";
import i18n from "../../../../../constants/initLng";
import DEFINE, { PATHS, UPLOAD_DIRECTORY, DETAIL_ACTIONS, FEATURE_FLAGS } from "../../../../../constants/Define";
import { message } from 'antd';
import { isEqual, get, debounce, find } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import Golf from '../../../../../models/Golf.js';
import Wrapper from '../../../common/component/Wrapper';
import Button from '../../../common/component/Button';
import BasicInfo from './BasicInfo';
import AddressInfo from './AddressInfo';
import { getProvinceByName } from '../../../../../models/Province';
import { cloneDeep } from 'lodash'

import './GolfDetail.less';
import TranslateButton from '../../../common/component/TranslateButton';

let permisionRateActions = [];
let permisionBookablePackageRateActions = [];
const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    isSubmit: false,
    isGetItem: false,
    validation: {}
};

export default class GolfDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            golf: this.props.golfState?.detail?.golf,
            uploadFiles: [],
            tagGroups: this.props.golfState?.tagGroups
        };
        this.basicInfoRef = React.createRef()
    }

    componentDidMount() {
        // this.initDetail()
        this.props.getListAmenities();
        this.props.getGolfDetail(this.props.match.params.id);
        this.props.getProvinces();
        this.props.getListLocations({
            orderByDesc: false,
            pageIndex: 0,
            pageSize: 100,
            isActive: true,
        });
        permisionRateActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.RATEPLAN);
        permisionBookablePackageRateActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.BOOKABLEPACKAGERATES);
    }

    componentWillUnmount() {
        this.props.setGolfDetail(new Golf())
        // this.props.setTagGroupDetailSku([])
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.golfState.detail.golf && !isEqual(nextProps.golfState.detail.golf, this.props.golfState.detail.golf)) {
            this.setGolfDetail(nextProps.golfState.detail.golf)
        }
        if (nextProps.uploadState.file && !isEqual(nextProps.uploadState.file, this.props.uploadState.file)) {
            this.processUploadedFiles(nextProps.uploadState.file);
        }
        if (nextProps.golfState.tagGroups && !isEqual(nextProps.golfState.tagGroups, this.props.golfState.tagGroups)) {
            this.setDataGroupTagDetail(nextProps.golfState.tagGroups);
            const tagsGroupChange = (nextProps.golfState.tagGroups || []).map(item => {
                return {
                    name: item.name,
                    tagGroupDetailId: item.id,
                    skuId: item.tagGroupDetailSkus?.[0]?.skuId,
                    isActiveListing: item.tagGroupDetailSkus?.[0]?.isActiveListing
                }
            })
            this.setState({ tagGroups: tagsGroupChange })
        }
    }

    render() {
        const { t, uploadState, golfState, generalState, locationState, amenityState } = this.props;
        const { isFetching } = golfState;
        const locations = locationState.dataList;
        const { action, isSubmit, isGetItem, validation, golf, tagGroups } = this.state;
        const { amenities } = amenityState;
        return (
            <LoadingComponent spinning={isFetching || generalState.isFetching || isSubmit}>
                <PageListComponent className="homestay-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'vinpearlGolf'}
                        group={'golfCourse'}
                        titleHeader={action === DETAIL_ACTIONS.CREATE
                            ? t('navigation.createGolfCourse')
                            : t('navigation.updateGolfCourse')}
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            <TranslateButton
                                languages={golf.translations}
                                current={!golf.languageCode ? 'vi-VN':golf.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChangeDetail('languageCode', language.code)}
                                onRemove={this.onRemoveTranslate} />
                        }
                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={isGetItem}
                        onClickBack={this.onClickBack}
                        backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                        titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        activeComponent={'SWITCH'}
                        onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                        titleActiveComponent={golf.active ? t(`item.homestay.active`) : t(`item.homestay.deActive`)}
                        submitButtonRight={true}
                        statusActiveName={`active`}
                        statusActive={golf.active}
                        additionalButton={this.renderFooterButtons()}
                    >
                        <Wrapper className='col-md-6 basic-section'>
                            <BasicInfo golf={golf}
                                action={action}
                                ref={this.basicInfoRef}
                                uploading={uploadState.isFetchingMultiple}
                                validation={validation}
                                onChange={this.onChangeDetail}
                                onUploadImage={this.onUploadImages}
                                onRemoveImage={this.removeImages}
                                amenities={amenities} />
                        </Wrapper>
                        <Wrapper className='col-md-6 address-section'>
                            <AddressInfo golf={golf}
                                action={action}
                                locations={locations}
                                provinces={generalState.provinces}
                                validation={validation}
                                onSelectPlace={this.onSelectPlace}
                                onChange={this.onChangeDetail}
                                tagGroups={tagGroups}
                                onChangeTags={this.onChangeTags} />
                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    renderFooterButtons() {
        const { action } = this.state;

        return (
            <Wrapper className="footer-manage-buttons">
                {action !== DETAIL_ACTIONS.TRANSLATE &&
                    <Fragment>
                        {/* <Button className="btn mr-2" icon="bars" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageRoomTypes}>{this.props.t(`navigation.roomTypes`)}</Button> */}
                        {/* <Button className="btn mr-2" icon="dollar" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageCustomPrices}>{this.props.t(`navigation.customPrices`)}</Button> */}
                        {/* {permisionRateActions && permisionRateActions.allowView && <Button className="btn mr-2" icon="dollar" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageRates}>{this.props.t(`navigation.rates`)}</Button>} */}
                        {/* { permisionBookablePackageRateActions && permisionBookablePackageRateActions.allowView && <Button className="btn mr-2" icon="container" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageBookablePackageRates}>{this.props.t(`navigation.bookablePackageRates`)}</Button> } */}
                        {/* <Button className="btn mr-2" icon="logout" onClick={this.onClickRateCompare}>{this.props.t(`navigation.rateCompare`)}</Button> */}
                    </Fragment>
                }
            </Wrapper>
        )
    }

    initDetail() {
        const { match, golfState } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            const golf = find(golfState.golfs, g => g.id === id);
            if (golf) this.setGolfDetail(golf);
            this.props.getGolfDetail(id);
            // this.props.getTagGroupDetailSku(id);
        }
        this.props.getProvinces();
        this.props.getListLocations({
            orderByDesc: false,
            pageIndex: 0,
            pageSize: 100,
            isActive: true,
        });
    }

    onChangeDetail = (fieldName, value) => {
        const golf = this.state.golf;
        golf[fieldName] = value;
        this.setState({ golf });
    };

    onChangeTags = (fieldName, value, index) => {
        const tagGroups = this.state.tagGroups;
        if (fieldName === 'isActiveListing') {
            tagGroups[index][fieldName] = value;
        }
        this.setState({ tagGroups });
    }

    setGolfDetail = (golfDetail) => {
        const golf = cloneDeep(golfDetail);
        if (this.basicInfoRef.current && this.basicInfoRef.current.setDescription && golfDetail.description) {
            this.basicInfoRef.current.setDescription(golfDetail.description)
        }
        this.setState({ golf, action: golf.id ? DETAIL_ACTIONS.UPDATE : this.state.action });

    }

    setDataGroupTagDetail = (tagsGruop) => {
        const tagsGroupChange = (tagsGruop || []).filter(item => item).map(item => {
            return {
                name: item.name,
                tagGroupDetailId: item.id,
                skuId: item.tagGroupDetailSkus?.[0]?.skuId,
                isActiveListing: item.tagGroupDetailSkus?.[0]?.isActiveListing
            }
        })
        this.setState({ tagGroups: tagsGroupChange })
    }

    onSelectPlace = (placeData) => {
        const { generalState } = this.props;
        const golf = this.state.golf;
        golf.address = placeData.address;
        golf.setPosition({ lat: placeData.lat, lng: placeData.lng });
        golf.country = placeData.place.address_components[placeData.place.address_components.length - 1].long_name || golf.country;
        golf.province = getProvinceByName(placeData.address, generalState.provinces);
        if (!golf.province) {
            golf.province = getProvinceByName(placeData.place.address_components[placeData.place.address_components.length - 2].long_name, generalState.provinces);
        }
        this.setState({ golf });
    }

    onSubmit = (e) => {
        e.preventDefault();
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else {
                this.updateGolfDetail()
            }
        }
    };

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.GOLF_COURSE.LIST.path);
        }
    }

    onShowTranslate = (language) => {
        const { golf } = this.state;
        // const {tagGroups} = this.props.hotelState;
        golf.setTranslate(language.code);
        golf.setData();
        // tagGroups.setTranslate(language.code);
        // tagGroups.setData();
        // Cập nhật trong DOM sau khi đã setData
        // if (this.basicInfoRef.current && this.basicInfoRef.current.setDescription) {
        //     this.basicInfoRef.current.setDescription(golf.description);
        // }
        this.setState({ golf, action: DETAIL_ACTIONS.TRANSLATE });
        this.tagGroupDetailTranslate(language);
    }

    tagGroupDetailTranslate = (language)=>{
        // const { tagGroups } = this.props.golfState;
        // let newGroupTags = tagGroups;
        // if(language && tagGroups){
        //     newGroupTags = (tagGroups || []).map(item => item.setTranslate(language))
        // }
        // this.setDataGroupTagDetail(newGroupTags);
    }

    onExitTranslate = () => {
        const golf = cloneDeep(this.state.golf);
        const action = DETAIL_ACTIONS[golf.id ? 'UPDATE' : 'CREATE'];
        const originalLanguageCode = golf.languageCode;
        
        golf.setTranslate(undefined, true);
        golf.setData();
        
        // Đảm bảo languageCode không bị mất sau khi gọi setTranslate
        if (!golf.languageCode) {
            golf.languageCode = originalLanguageCode || 'vi-VN';
        }
        
        this.tagGroupDetailTranslate(undefined);
        this.setState({ golf, action });
    }

    onSaveTranslate = () => {
        const { golf } = this.state;
        const translateFunction = this.props.updateGolfTranslate;
        translateFunction(golf, golf.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { golf } = this.state;
        golf.setTranslate(language.code);
        this.props.deleteGolfTranslate(golf, { id: golf.id });
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.golf.name`)),
                code: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.golf.code`)),
                hotline: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.golf.hotline`)),
                email: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.golf.email`)),
                website: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.golf.website`)),
                locationId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.homestay.location`)),
            },
            isEmail: { 
                email: t('validation.email'),
            },
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        if (this.state.golf.installmentFee || this.state.golf.installmentLimit) {
            validate.required.installmentFee = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.installmentFee`))
            validate.required.installmentLimit = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.installmentLimit`))
        }
        let valueValidate = {

        };
        const result = Func.multipleValidate(this.state.golf, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    processUploadedFiles(fileObj) {
        let uploadFiles = this.state.uploadFiles;
        const golf = this.state.golf;
        golf.addMedia(get(fileObj, 'data.fileUrl'), get(fileObj, 'data.fileName'))
        this.setState({ golf, uploadFiles });
    }

    onUploadImages = (file) => {
        let fileData = file.target.files;
        let uploadFiles = this.state.uploadFiles;
        if (fileData.length > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        } else if ((uploadFiles.length + fileData.length) > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        }
        let imageValidation = ['image/jpeg', 'image/jpg', 'image/png'];
        Object.keys(fileData).map((i) => {
            if (imageValidation.includes(fileData[i].type)) {
                this.props.onUploadFile({ file: fileData[i], directory: UPLOAD_DIRECTORY.HOTEL, isFile: 2 })
            } else {
                message.error(i18n.t('validation.image'))
            }
        })
    }


    removeImages = (i, k) => {
        if (!i) return;
        const golf = this.state.golf;
        if (i === "https://null") {
            golf.media = golf.media.filter((i, index) => index !== k)
        } else {
            golf.removeMedia(i)
        }
        this.setState({ golf });
    };

    updateGolfDetail() {
        const { golf, action, tagGroups } = this.state;
        const actionFunction = this.props.updateGolfDetail;
        actionFunction(golf);
        // if(action === DETAIL_ACTIONS.UPDATE){
        //     this.props.updateTagGroupDetailSkuActive(tagGroups, golf.id)
        // }
    }

}
